import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// bayclubs modules
import { UtilsModule } from '@bayclubs/utils';
import { DropDownModule } from '@bayclubs/drop-down';

// services
import { GcNavigationService } from './services/gc-navigation.service';
import { GlobalEventsService } from './services/events/global-events.service';
import { CalendarService } from './services/calendar.service';
import { SlotProviderService } from './services/slot-provider.service';
import { ErrorTranslationService } from './services/error-translation.service';
import { GroupClassesSecurityService } from './services/group-classes-security.service';

// components
import { ServerErrorComponent } from './components/server-error/server-error.component';
import { DatePickerMultiselectComponent } from './components/date-picker-multiselect/date-picker-multiselect.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { GroupDropDownComponent } from './components/group-drop-down/group-drop-down.component';

// pipes
import { InputFocusDirective } from './directives/input.focus.directive';
import { InitialsPipe } from './pipes/initials.pipe';
import { SingleItemArrayPipe } from './pipes/singleItemArray.pipe';

@NgModule({
    declarations: [
        ServerErrorComponent,
        DatePickerMultiselectComponent,
        InitialsPipe,
        SingleItemArrayPipe,
        CheckboxComponent,
        InputFocusDirective,
        InitialsPipe,
        GroupDropDownComponent
    ],
    imports: [
        CommonModule,
        UtilsModule,
        TranslateModule.forChild(),
        FormsModule,
        ReactiveFormsModule,
        DropDownModule
    ],
    exports: [
        DatePickerMultiselectComponent,
        CheckboxComponent,
        InitialsPipe,
        SingleItemArrayPipe,
        GroupDropDownComponent,
        InputFocusDirective
    ]
})
export class InfrastructureModule {
    static forRoot(): ModuleWithProviders<InfrastructureModule> {
        return {
            ngModule: InfrastructureModule,
            providers: [
                GcNavigationService,
                GlobalEventsService,
                CalendarService,
                SlotProviderService,
                ErrorTranslationService,
                GroupClassesSecurityService
            ]
        };
    }
}

// models
export { SlotModel } from './models/slot-model';
export { OnAddEditGroupClass } from './services/events/on-add-edit-group-class';

// services
export { GroupClassesSecurityService } from './services/group-classes-security.service';
export { GlobalEventsService } from './services/events/global-events.service';
export { SlotProviderService } from './services/slot-provider.service';

// components
export { DatePickerMultiselectComponent } from './components/date-picker-multiselect/date-picker-multiselect.component';
export { GroupDropDownComponent } from './components/group-drop-down/group-drop-down.component';

// guards
export { GcPermissionGuard } from './services/gc-permission.guard';
